import React from 'react';
import SectionTitle from './SectionTitle';
import ContactGrid from '../../ContactGrid';
import logoSagaImage from '../../../../images/features/saga/logo_saga.png';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SectionContainer from './SectionContainer';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
  logoContainer: {
    textAlign: 'center',
    margin: theme.spacing(6, 0),
  },
  logo: {
    maxWidth: 200,
  },
}));

const Partners = () => {
  const classes = useStyles();
  return (
    <SectionContainer className={classes.container}>
      <SectionTitle title="連携パートナー" subtitle="PARTNER" />
      <div className={classes.logoContainer}>
        <img src={logoSagaImage} alt="佐賀県" className={classes.logo} />
      </div>
      <ContactGrid>
        他にも連携希望の市町村募集しております！人手不足等の困り事をキッカケに、一緒に関係人口を創出しましょう。ご希望の方はこちらのフォームからお気軽にお問い合わせください。
      </ContactGrid>
    </SectionContainer>
  );
};

export default Partners;
